import axios from 'axios'
import store from '@/store'

const API_URL = process.env.VUE_APP_API_URL
const APP_URL = process.env.VUE_APP_APP_URL

export class Api {
  async login (params) {
    const url = API_URL + params.route
    const oParams = new URLSearchParams()

    Object.keys(params).forEach((key) => {
      oParams.append(key, params[key])
    })

    return axios
      .post(url + '?nocache=' + new Date().getTime(), oParams, {
        withCredentials: true
      })
      .then(function (response) {
        if (response.status === 200) return response.data
      })
  }

  async get (uri) {
    const token = store.getters.getToken
    axios.defaults.headers.common['Authorization'] = token

    const url = API_URL + uri
    return axios
      .get(url, {
        withCredentials: true,
        validateStatus: function (status) {
          if (status === 403) {
            window.location.href = APP_URL + 'login'
          }
          return true
        }
      })
      .then(function (response) {
        return response.data
      })
  }

  async post (uri, params) {
    const token = store.getters.getToken
    axios.defaults.headers.common['Authorization'] = token

    const oParams = new URLSearchParams()
    Object.keys(params).forEach((key) => {
      oParams.append(key, params[key])
    })

    const url = API_URL + uri
    return axios
      .post(url, oParams, {
        withCredentials: true,
        validateStatus: function (status) {
          if (status === 403) {
            window.location.href = APP_URL + 'login'
          }
          return true
        }
      })
      .then(function (response) {
        return response.data
      })
  }

  postJSON (uri, params = {}) {
    const url = API_URL + uri

    return axios.post(
      url,
      params,
      {
        withCredentials: true,
        headers: {
          'Authorization': localStorage.token || '',
          'Content-Type': 'application/json'
        },
        validateStatus (status) {
          if (status === 403) {
            window.location.href = APP_URL + 'login'
          }
          return true
        }
      }
    ).then(res => res.data)
  }

  async language (lang) {
    const token = store.getters.getToken
    axios.defaults.headers.common['Authorization'] = token

    const url = API_URL + 'language/' + lang
    return axios
      .get(url, {
        withCredentials: true,
        validateStatus: function (status) {
          if (status === 403) {
            window.location.href = APP_URL + 'login'
          }
          return true
        }
      })
      .then(function (response) {
        return response.data
      })
  }

  async import (uri, params) {
    const token = store.getters.getToken
    axios.defaults.headers.common['Authorization'] = token

    const url = API_URL + uri
    return axios
      .post(url, params, {
        withCredentials: true,
        validateStatus: function (status) {
          if (status === 403) {
            window.location.href = APP_URL + 'login'
          }
          return true
        }
      })
      .then(function (response) {
        return response.data
      })
  }
}
